import { useMemo } from "react"

import { twMerge } from "tailwind-merge"

import { FieldError } from "./FieldError"
import { useFieldContext } from "./FieldProvider"
import { dataFlag } from "~/src/lib/jsx"

export type FieldErrorsProps = {
  className?: string
  errorMessages?: string[]
}

export function FieldErrors(props: FieldErrorsProps) {
  const { className, errorMessages: errorMessages_ } = props

  const fieldContext = useFieldContext()

  const errorMessages = useMemo(
    () => errorMessages_ ?? fieldContext?.errorMessages ?? [],
    [errorMessages_, fieldContext]
  )
  const hasErrors = fieldContext?.hasErrors ?? false

  return (
    <div
      className={twMerge("flex flex-col", "invisible data-errored:visible", className)}
      {...dataFlag(hasErrors, "errored")}
    >
      {hasErrors && errorMessages.map((errorMessage) => <FieldError key={errorMessage} message={errorMessage} />)}
      {!hasErrors && <FieldError message="&nbsp;" />}
    </div>
  )
}
